/** @file A vector rotated by a unit quaternion. */
import type { Vec3 } from '../vec3/vec3';
import type { Quat } from './quat';

/**
 * `q v q*`. Expanding the sandwich product for q = (u, w), |q| = 1, gives `v + 2w (u x v) + 2 u x (u x v)`;
 * with `t = 2 (u x v)` that is `v + w t + u x t`.
 */
export function quatRotateVec3(q: Quat, v: Vec3): Vec3 {
  const [x, y, z, w] = q;
  const [vx, vy, vz] = v;
  const tx = 2 * (y * vz - z * vy);
  const ty = 2 * (z * vx - x * vz);
  const tz = 2 * (x * vy - y * vx);
  return [vx + w * tx + (y * tz - z * ty), vy + w * ty + (z * tx - x * tz), vz + w * tz + (x * ty - y * tx)];
}
